import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { selectIsUserAuthenticated } from 'features/auth/selectors'

import BalancePolling from './BalancePolling/BalancePolling'
import CarouselSliderPolling from './CarouselSliderPolling'
import LimitsPolling from './LimitsPolling/LimitsPolling'
import PromotionsPolling from './PromotionsPolling/PromotionsPolling'

export const AppGlobalPolling = () => {
  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)

  return (
    <>
      <BalancePolling key={String(isAuth)} />
      {isAuth && <PromotionsPolling />}
      <LimitsPolling />
      <CarouselSliderPolling />
    </>
  )
}
